import { render, staticRenderFns } from "./editPtSession.vue?vue&type=template&id=2f1de381&"
import script from "./editPtSession.vue?vue&type=script&lang=js&"
export * from "./editPtSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports